function ssConfetti() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const btn = document.querySelector('#AddToCart') || document.body;
  const rect = btn.getBoundingClientRect();
  const x = rect.left + rect.width / 2;
  const y = rect.top + rect.height / 2;

  const colors = ['#75AADB', '#75AADB', '#FFFFFF', '#4A90D9', '#A9D0F5'];
  const count = 70;

  for (let i = 0; i < count; i++) {
    const p = document.createElement('span');
    const isStrip = Math.random() > 0.55;
    const w = isStrip ? 4 : 8;
    const h = isStrip ? 14 : 8;
    p.style.cssText = `position:fixed;pointer-events:none;z-index:9999;width:${w}px;height:${h}px;left:${x}px;top:${y}px;will-change:transform,opacity;box-shadow:0 0 1px rgba(0,0,0,.2);background:${colors[Math.floor(Math.random()*colors.length)]};${isStrip ? '' : (Math.random() > 0.5 ? 'border-radius:50%;' : '')}`;
    document.body.appendChild(p);

    const angle = Math.random() * Math.PI * 2;
    const velocity = 120 + Math.random() * 320;
    const dx = Math.cos(angle) * velocity;
    const dy = Math.sin(angle) * velocity - 180;
    const fall = 320 + Math.random() * 260;
    const rot = Math.random() * 1080 - 540;

    p.animate([
      { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
      { transform: `translate(${dx*0.5}px, ${dy}px) rotate(${rot*0.5}deg)`, opacity: 1, offset: 0.35 },
      { transform: `translate(${dx}px, ${dy + fall}px) rotate(${rot}deg)`, opacity: 0 }
    ], {
      duration: 1400 + Math.random() * 700,
      easing: 'cubic-bezier(.15,.6,.4,1)'
    }).onfinish = () => p.remove();
  }
}

const _fetch = window.fetch;
window.fetch = function (...args) {
  const url = (args[0] && args[0].url) || args[0] || '';
  return _fetch.apply(this, args).then(res => {
    if (typeof url === 'string' && url.includes('/cart/add') && res.ok) {
      ssConfetti();
    }
    return res;
  });
};